import { memo } from 'react';
import { hasPerm, P } from '../../../../../utilities/roles/permissions';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';
import { defaultHeaderRenderer } from '../headers';
import { RightAlign } from '../styles';
import { IColumn } from '../types';

const CenterAlignFormatter = memo(function formatter(cellProps: CellProps) {
  return (
    <CellEventsHandler cellProps={cellProps}>
      <RightAlign>{cellProps.row.lastTouch}</RightAlign>
    </CellEventsHandler>
  );
});

export const TOUCHColumn = (): IColumn => ({
  item: {
    key: 'lastTouch',
    name: 'Touch',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(72px, .5fr)',
    formatter: CenterAlignFormatter,
  },
  visible: ({ role }) => hasPerm(role, P.LAST_TOUCH_VIEW),
});
